'use strict';

export enum KeyboardKey {
  Enter = 'Enter',
}
